import { useDisclosure } from "@mantine/hooks";
import { useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { Button, Group, Modal, Text } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { editWorkflow } from "../../../../../api/WorkflowAPI";
import { IconArchiveOff } from "@tabler/icons-react";

const UnarchiveWorkflow = ({ current, disabled, onFinish }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();
  const [loading, setLoading] = useState(false);

  const main = () => {
    setLoading(true);
    editWorkflow({
      id: current.id,
      archived: false,
    })
      .then((res) => {
        close();
        notifications.show({
          message: lang.statistics.unarchive.success_workflow,
          color: "tertiary.8",
        });
        onFinish?.();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Button
        onClick={open}
        leftSection={<IconArchiveOff size={18} />}
        color="tertiary.8"
        variant="subtle"
        justify="start"
        disabled={disabled}
      >
        {lang.statistics.unarchive.label_workflow}
      </Button>

      <Modal
        opened={opened}
        onClose={close}
        title={
          <Text size="md" truncate="end">
            {lang.statistics.unarchive.dialog_workflow.title} #{current?.id}
          </Text>
        }
        centered
        styles={{
          content: {
            boxShadow: "red 0 0 6px",
            border: "1px solid #a00",
          },
          title: {
            maxWidth: "92%",
          },
        }}
      >
        <Text size="sm">
          {lang.statistics.unarchive.dialog_workflow.text} <br />
          <b>{lang.statistics.unarchive.dialog_workflow.text2}</b>
        </Text>

        <Group justify="end" mt={"sm"}>
          <Button variant="subtle" onClick={close} disabled={loading}>
            {lang.components.deletion_action.dialog.cancel_button}
          </Button>
          <Button color="tertiary.8" onClick={main} loading={loading}>
            {lang.statistics.unarchive.dialog.submit_button}
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default UnarchiveWorkflow;
